import React, { useEffect, useState } from 'react';
import { adminApi } from '../api/client';
import './css/admin-socials.css';

const EMPTY = { platform: '', label: '', url: '', cls: 'x', status: 'draft', sort_order: 0 };

const CLS_OPTIONS = ['yt', 'ig', 'x', 'tt', 'fb', 'dc'];

export default function AdminSocials() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => {
    adminApi.getSocials().then(setItems).catch((e) => setError(e.message));
  };

  useEffect(() => { load(); }, []);

  const resetForm = () => {
    setForm(EMPTY);
    setEditingId(null);
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setForm({
      platform: item.platform,
      label: item.label,
      url: item.url,
      cls: item.cls,
      status: item.status,
      sort_order: item.sort_order,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (editingId) {
        await adminApi.updateSocial(editingId, form);
      } else {
        await adminApi.createSocial(form);
      }
      resetForm();
      load();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this social link?')) return;
    try {
      await adminApi.deleteSocial(id);
      if (editingId === id) resetForm();
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-page admin-page--socials">
      <header className="admin-page-header">
        <h1>Social Links</h1>
        <p>Manage community links shown on the homepage and roadmap footer.</p>
      </header>

      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-two-col">
        <form className="admin-card admin-form" onSubmit={handleSubmit}>
          <h2>{editingId ? 'Edit Link' : 'New Link'}</h2>

          <label className="admin-label">
            Platform ID
            <input className="admin-input" value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })} placeholder="youtube" required />
          </label>

          <label className="admin-label">
            Display Label
            <input className="admin-input" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} required />
          </label>

          <label className="admin-label">
            URL
            <input className="admin-input" type="url" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} required />
          </label>

          <div className="admin-form-row">
            <label className="admin-label">
              Icon Style
              <select className="admin-select" value={form.cls} onChange={(e) => setForm({ ...form, cls: e.target.value })}>
                {CLS_OPTIONS.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>

            <label className="admin-label">
              Sort Order
              <input className="admin-input" type="number" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: Number(e.target.value) })} />
            </label>
          </div>

          <label className="admin-label">
            Status
            <select className="admin-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </label>

          <div className="admin-form-actions">
            <button type="submit" className="admin-btn admin-btn-primary" disabled={saving}>
              {saving ? 'Saving...' : editingId ? 'Update' : 'Create'}
            </button>
            {editingId && (
              <button type="button" className="admin-btn admin-btn-ghost" onClick={resetForm}>Cancel</button>
            )}
          </div>
        </form>

        <div className="admin-list">
          {items.map((item) => (
            <article key={item.id} className="admin-list-card">
              <div className="admin-list-card-header">
                <h3>{item.label}</h3>
                <span className={`admin-badge admin-badge-${item.status}`}>{item.status}</span>
              </div>
              <p className="admin-list-card-body">{item.url}</p>
              <p className="admin-list-meta">Icon: {item.cls} · Order: {item.sort_order}</p>
              <div className="admin-list-actions">
                <button type="button" className="admin-btn admin-btn-sm" onClick={() => handleEdit(item)}>Edit</button>
                <button type="button" className="admin-btn admin-btn-sm admin-btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
